export const kidsTrackingFeaturesList = [
    {
        id: '1',
        title: 'Location History',
        content: "Review your child's daily routes and stops in the last month with our comprehensive location history to check they’re sticking to safe paths and routines.",
        imgName: 'locationHistoryCarousel'
    },
    {
        id: '2',
        title: 'Live Location Sharing',
        content: "Track your child’s location in real time, without having to send a text or make a call. Perfect for those moments when you just need a quick update.",
        imgName: 'locationSharingCarousell'
    },
    {
        id: '3',
        title: 'Emergency Alert',
        content: 'If your child ever feels unsafe, they can send an instant emergency alert, telling you something is wrong, so you can take action, using their live location.',
        imgName: 'newEmergencyAlertCaousell'
    },
    {
        id: '4',
        title: 'Geofence Alerts',
        content: 'Set up automatic notifications for key places like home, school, or a friend’s house. Get an alert when they arrive or leave, so you always know they’re safe.',
        imgName: 'familyCarousel'
    },
    {
        id: '5',
        title: 'Instant Messaging',
        content: "A simple, secure way to stay in touch. Send quick messages without switching between multiple apps, or spending too much time on social media. ",
        imgName: 'messegesCarousel'
    },
];